import React, { useEffect } from "react";
import M from "materialize-css";
import "./reparadoras.css";
import AOS from "aos"; 
import "aos/dist/aos.css"; 

function PageReparadoras() {
  useEffect(() => {
    M.Modal.init(document.querySelectorAll(".modal"), {});
    M.Collapsible.init(
      document.querySelectorAll(".collapsible.procedimentos"),
      {}
    );
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      delay: 100,
    });
  }, []);

  const procedimentos = [
    {
      id: "modal01",
      titulo: "Cirurgia Reconstrutora Pós-Câncer:",
      descricao:
        "A cirurgia reconstrutora pós-câncer de pele é um procedimento que combina a remoção de tumores cutâneos com técnicas avançadas de reconstrução. Indicada para pacientes que enfrentaram, ou estão enfrentando, um câncer de pele, a cirurgia visa restaurar a estética e a funcionalidade, promovendo bem-estar. As técnicas incluem excisão e fechamento direto, enxertos ou retalhos para minimizar cicatrizes. Especialmente em reconstruções faciais (nariz, pálpebras, orelhas), o planejamento é personalizado, considerando a necessidade funcional e estética.",
      modalContent: {
        titulo: "Dúvidas Frequentes",
        descricao: "",
        perguntas: [
          {
            pergunta: "Quem pode fazer cirurgia reconstrutora pós-câncer?",
            resposta:
              "Pacientes que necessitam remover tumores cutâneos ou reconstruir áreas afetadas por câncer.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva de 2 a 4 semanas, dependendo do procedimento.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas podem ser influenciados por fatores como envelhecimento e cuidados pós-operatórios.",
          },
          {
            pergunta: "A cirurgia é funcional ou apenas estética?",
            resposta:
              "Ambas. O objetivo é restaurar tanto a função quanto a aparência da área tratada.",
          },
        ],
      },
    },
    {
      id: "modal02",
      titulo: "Tratamento de Sequelas de Traumas",
      descricao:
        "O tratamento de sequelas de traumas visa corrigir deformidades ou melhorar cicatrizes deixadas por acidentes, queimaduras ou cirurgias prévias. Indicada para pacientes que enfrentam impacto estético ou funcional afetando sua qualidade de vida. A cirurgia é planejada de forma personalizada para devolver harmonia e bem-estar, na medida do possível. Os procedimentos incluem a correção de deformidades em tecidos moles, como reparação de cicatrizes extensas, quelóides ou hipertróficas. Técnicas avançadas, como liberação de cicatrizes retraídas, enxertos de gordura, retalhos, enxertos cutâneos e outros métodos, são utilizadas para resultados naturais e duradouros.",
      modalContent: {
        titulo: "Dúvidas Frequentes",
        descricao: "",
        perguntas: [
          {
            pergunta: "Quem pode fazer tratamento de sequelas de traumas?",
            resposta:
              "Pacientes com deformidades ou cicatrizes que impactam a estética, ou a funcionalidade, e afetam negativamente sua qualidade de vida.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "O objetivo é que as novas cicatrizes sejam mais discretas que as anteriores e, sempre que possível, posicionadas de forma estratégica para melhorar o aspecto geral e a funcionalidade.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva de 2 a 4 semanas, dependendo da extensão da cirurgia.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas podem ser influenciados por fatores como cicatrização e cuidados pós-operatórios.",
          },
        ],
      },
    },
    {
      id: "modal03",
      titulo: "Cirurgias para Anomalias Congênitas",
      descricao:
        "As cirurgias para anomalias congênitas visam corrigir deformidades presentes desde o nascimento, melhorando tanto a estética quanto a funcionalidade. Indicadas para condições como fissura labiopalatina (lábio leporino e fenda palatina), sindactilia (dedos unidos) e polidactilia (dedos extras), essas cirurgias são essenciais para o desenvolvimento e a qualidade de vida do paciente. Os procedimentos são planejados de forma personalizada, com técnicas avançadas para resultados estéticos e funcionais duradouros. O acompanhamento contínuo é fundamental para ajustes e otimização dos resultados ao longo do crescimento.",
      modalContent: {
        titulo: "Dúvidas Frequentes",
        descricao: "",
        perguntas: [
          {
            pergunta: "Quem pode fazer cirurgias para anomalias congênitas?",
            resposta:
              "Pacientes com deformidades congênitas que afetam a funcionalidade ou a aparência.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial varia entre 2 a 4 semanas, com acompanhamento contínuo.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas podem requerer ajustes ao longo do crescimento do paciente.",
          },
          {
            pergunta: "As cirurgias restauram completamente a funcionalidade?",
            resposta:
              "Na maioria dos casos, sim. O objetivo é melhorar significativamente a função e a estética.",
          },
        ],
      },
    },
  ];

  return (
    <div>
      <div>
        <div>
          <h3 className="titulo-cirurgias-page-reparadoras">
            Cirurgias Reparadoras
          </h3>
        </div>
        <div className="red-section" data-aos="fade-left" data-aos-delay="200">
          <h5 className="red-section-title">
            Transformando vidas com procedimentos reparadores
          </h5>
          <p className="red-section-text">
            Nosso compromisso vai além da estética: é sobre devolver confiança,
            funcionalidade e bem-estar. Procedimentos reparadores e
            reconstrutores oferecem a oportunidade de superar marcas deixadas
            por traumas, queimaduras, cirurgias ou condições congênitas. Com um
            cuidado humanizado e técnicas avançadas, buscamos não apenas
            restaurar, mas valorizar sua individualidade. Juntos, vamos
            ressignificar sua jornada, trazendo harmonia e renovação. Porque
            cada detalhe importa, e você merece se sentir completo novamente.
          </p>
        </div>
      </div>

      <div className="procedimentos-reparadores" data-aos="fade-up">
        {procedimentos.map((procedimento, index) => (
          <div key={index} className="container-reparadoras row hoverable">
            <div className="col s12">
              <h5 className="container-reparadoras-title">
                {procedimento.titulo}
              </h5>
              <p className="container-reparadoras-description">
                {procedimento.descricao}
              </p>
              <a
                className="modal-trigger custom-btn"
                href={`#${procedimento.id}`}
              >
                Dúvidas frequentes
              </a>
            </div>
          </div>
        ))}

        {procedimentos.map((procedimento) => (
          <div key={procedimento.id} id={procedimento.id} className="modal">
            <a href="#!" className="modal-close btn-close-icon">
              <i className="material-icons">close</i>
            </a>
            <div className="modal-content">
              <h4 className="modal-title-reparadoras-page">
                {procedimento.modalContent.titulo}
              </h4>
              <ul className="collapsible procedimentos collapsible-reparadoras">
                {procedimento.modalContent.perguntas.map((pergunta, idx) => (
                  <li key={idx}>
                    <div className="collapsible-header procedimentos-header-page-reparadoras">
                      {pergunta.pergunta}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </div>
                    <div className="collapsible-body procedimentos-body-page-reparadoras">
                      <p className="question-page-reparadoras">
                        {pergunta.resposta}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PageReparadoras;
